import { render, staticRenderFns } from "./ConsoleChart2.vue?vue&type=template&id=3401838d&scoped=true"
import script from "./ConsoleChart2.vue?vue&type=script&lang=js"
export * from "./ConsoleChart2.vue?vue&type=script&lang=js"
import style0 from "./ConsoleChart2.vue?vue&type=style&index=0&id=3401838d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3401838d",
  null
  
)

export default component.exports